import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { yupLocalized } from "@ryde/shared";

import {
  BulkPassengersMessageFormFieldsEnum,
  LAST_RIDE_WITHIN_DAYS_LIMITS,
} from "./bulk-passengers-message.models";

export const useBulkPassengersMessageValidation = () => {
  const { t } = useTranslation();
  const basePath = "passenger.sendPassengerMessageForm";

  const bulkPassengersMessageResolver = useMemo(() => {
    return {
      [BulkPassengersMessageFormFieldsEnum.isEmail]: yupLocalized
        .boolean()
        .optional(),

      [BulkPassengersMessageFormFieldsEnum.isSms]: yupLocalized
        .boolean()
        .optional(),

      [BulkPassengersMessageFormFieldsEnum.isPush]: yupLocalized
        .boolean()
        .optional(),

      [BulkPassengersMessageFormFieldsEnum.subject]: yupLocalized
        .string()
        .when(BulkPassengersMessageFormFieldsEnum.isEmail, {
          is: true,
          then: schema =>
            schema.required(
              t("validation.required", {
                path: t(`${basePath}.subject`),
              }),
            ),
          otherwise: schema => schema.notRequired(),
        }),

      [BulkPassengersMessageFormFieldsEnum.message]: yupLocalized
        .string()
        .required(
          t("validation.required", {
            path: t(`${basePath}.message`),
          }),
        ),

      // Optional filter: an empty field means "do not filter", so only a filled value is validated.
      [BulkPassengersMessageFormFieldsEnum.lastRideWithinDays]: yupLocalized
        .number()
        .nullable()
        .integer()
        .min(LAST_RIDE_WITHIN_DAYS_LIMITS.min)
        .max(LAST_RIDE_WITHIN_DAYS_LIMITS.max)
        .transform(value => (Number.isFinite(value) ? value : null))
        .notRequired(),
    };
  }, [t]);

  return {
    bulkPassengersMessageResolver,
  };
};
